
import {
  computed, defineComponent, Ref, ref,
} from 'vue';
import { useClipboard } from '@vueuse/core';
import { useProfileStore } from '../store/profileStore';
import {
  IFileUpload, IImageCrop, IPhoto, IProfile,
} from '@/types/interfaces';
import { useMainStore } from '@/store/mainStore';
import UseUpload from '@/composables/UseUpload';
import UploadService from '@/services/UploadService';
import ProfileService from '../services/ProfileService';
import AppTakePhoto from '@/components/AppTakePhoto.vue';
import AppLazyImage from '@/components/UI/AppLazyImage.vue';
import { PHOTO_VIEW_TYPE, UPLOAD_PLACES } from '@/types/enums';
import { lowResUrlByViewTypeByUrl } from '@/helpers/lowResPhotoUrl';

export default defineComponent({
  props: {
    user: { type: Object as () => IProfile, required: true },
    isMyProfile: { type: Boolean, default: true },
    skeleton: { type: Boolean, default: false },
  },
  components: {
    AppTakePhoto,
    // AppLoader,
    // AppUploadInfo,
    AppLazyImage,
  },
  setup(props) {
    const mainStore = useMainStore();
    const profileStore = useProfileStore();
    // const dataLoading: Ref<boolean> = ref(false);
    const fileInputKey = ref(0);
    const imageToCrop = ref({} as IImageCrop);

    const fileInput: Ref<HTMLInputElement | null> = ref(null);

    const { uploadInfo, onUploadUpdate } = UseUpload();
    const { copy, copied } = useClipboard();

    const loaderText = computed(
      () => '',
    );

    const fullName = computed(() => `${props.user.firstName || ''} ${props.user.lastName || ''}`);
    const profession = computed(() => {
      if (props.user.vendorField) {
        return `${props.user.professionSpeciality?.label || ''} - ${props.user.vendorField}`;
      }
      return '';
    });
    const speciality = computed(() => mainStore.specialities.find((specialityItem) => specialityItem.value === props.user.speciality?.value)?.label);

    const email = computed(() => profileStore.profile.caseDriveEmail || '');

    const photoUrl = computed(() => {
      if (props.user.photo?.url) {
        // return process.env.VUE_APP_MEDIA_URL + props.user.photo.url;
        return lowResUrlByViewTypeByUrl(props.user.photo.url, PHOTO_VIEW_TYPE.WHMED);
      }
      // eslint-disable-next-line global-require
      return require('@/assets/img/mockup/profile.svg');
    });

    function savePhoto(event: Event) {
      if (!props.isMyProfile) {
        return;
      }

      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const img: File = (event.target as HTMLInputElement).files![0];

      imageToCrop.value = {
        url: URL.createObjectURL(img),
        fileName: img.name,
        fileType: img.type,
      };
      fileInputKey.value += 1;

      fileInput.value!.value = '';
    }

    function handleCroppedImage(fileUpload: {file: IFileUpload[]}) {
      imageToCrop.value = {} as IImageCrop;
      // dataLoading.value = true;

      UploadService.batchUploadTUS(fileUpload.file, onUploadUpdate, { location: UPLOAD_PLACES.PROFILE_PHOTO }, undefined, [], true, true)
        .then((mediaList) => {
          const photo = mediaList[0];
          return ProfileService.saveProfilePhoto(photo.id);
        })
        .then((response) => {
          if (response.success) {
            const photo: IPhoto = {
              id: response.results.data.split('/')[2],
              url: `${response.results.data}?timestamp=${Date.now()}`,
            };
            profileStore.updatePhoto(photo);
          }
        });
      // .finally(() => { dataLoading.value = false; });
    }

    function cancelUpload() {
      UploadService.isAbortUpload = true;
      // dataLoading.value = false;
    }

    function onCopy() {
      copy(email.value);
      // NotificationService.notifySuccess('Sending files to this email equal to uploading files to your drive');
    }

    return {
      savePhoto,
      handleCroppedImage,
      cancelUpload,
      photoUrl,
      // dataLoading,
      uploadInfo,
      fullName,
      speciality,
      profession,
      fileInput,
      fileInputKey,
      imageToCrop,
      loaderText,
      email,
      onCopy,
      copied,
    };
  },
});
